import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../lib/authStore';

export default function RequireAuth({ children }) {
  const isAuthenticated = useAuthStore((s) => !!s.accessToken);
  const location = useLocation();
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  return children;
}
